var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleCheckWhite = function SvgCircleCheckWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle-check-white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 8.763 3.38-3.382 1.238 1.238-4 4a.877.877 0 0 1-1.237 0l-2-2L5.618 7.38 7 8.763Z",
    fill: "#214FB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle-check-white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgCircleCheckWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI5XzI1OTEpIj4KPHBhdGggZD0iTTAgOEMwIDMuNTgxMjUgMy41ODEyNSAwIDggMEMxMi40MTg3IDAgMTYgMy41ODEyNSAxNiA4QzE2IDEyLjQxODcgMTIuNDE4NyAxNiA4IDE2QzMuNTgxMjUgMTYgMCAxMi40MTg3IDAgOFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik02Ljk5OTYxIDguNzYyNkwxMC4zODA5IDUuMzgxMzVMMTEuNjE4NCA2LjYxODg1TDcuNjE4MzYgMTAuNjE4OEM3LjI3NzczIDEwLjk1OTUgNi43MjE0OCAxMC45NTk1IDYuMzgwODYgMTAuNjE4OEw0LjM4MDg2IDguNjE4ODVMNS42MTgzNiA3LjM4MTM1TDYuOTk5NjEgOC43NjI2WiIgZmlsbD0iIzIxNEZCNyIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI5XzI1OTEiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";